import { render, staticRenderFns } from "./normal-sign.vue?vue&type=template&id=31b4f08d&scoped=true&"
import script from "./normal-sign.vue?vue&type=script&lang=js&"
export * from "./normal-sign.vue?vue&type=script&lang=js&"
import style0 from "./normal-sign.vue?vue&type=style&index=0&id=31b4f08d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4f08d",
  null
  
)

export default component.exports